<script setup lang="ts">
import { analytics } from '@/scitylana';

import TruButton from '../TruButton.vue';
import TruCard from '../TruCard.vue';

function gotoColleagueConsult() {
    analytics.home.colleagueConsult();

    window.open('https://colleague-consult.trupanion.com');
}
</script>

<template>
    <div class="colleague-consult">
        <TruCard>
            <div class="colleague-consult flex">
                <div class="left flex flex-col mr-4">
                    <img
                        class="logo mb-6"
                        src="../../assets/images/colleague-consult-logo.png"
                        :alt="$t('dashboard.colleagueConsult.logoAltText')"
                    >

                    <div class="desk-body-reg mb-6">
                        {{ $t('dashboard.colleagueConsult.body') }}
                    </div>

                    <TruButton
                        secondary
                        size="xs"
                        @click="gotoColleagueConsult"
                    >
                        {{ $t('dashboard.colleagueConsult.button') }}
                    </TruButton>
                </div>

                <div class="right flex flex-col justify-center">
                    <img
                        src="../../assets/images/colleague-consult.png"
                        :alt="$t('dashboard.colleagueConsult.altText')"
                    >
                </div>
            </div>
        </TruCard>
    </div>
</template>

<style scoped lang="scss">
.colleague-consult {
    .logo {
        width: 195px;
    }

    .right {
        img {
            width: 227px;
        }
    }

    .left {
        .tru-button {
            width: fit-content;
        }
    }
}
</style>
